export default __webpack_public_path__ + "static/media/ok.globe.901e3500.png";